import { Stack } from 'expo-router';
import React from 'react';

export default function CampaignLayout() {
  return (
    <Stack>
      <Stack.Screen name="index" options={{ title: 'Select Campaign' }} />
      <Stack.Screen name="[campaignId]" options={{ title: 'Campaign', headerShown: false }} />
    </Stack>
  );
} 